<template>
  <div class="legal-category">
    <div class="legal-category__header">
      <span class="legal-category__title">{{ category.title }}</span>
    </div>
    <div class="legal-category__list">
      <template v-if="category.secondItems && category.secondItems.length">
        <div
          v-for="(item, index) in visibleItems"
          :key="index"
          class="legal-category__item"
          @click="handleItemClick(item)"
        >
          <span class="legal-category__item-text" v-html="formatTitle(item.title, index)"></span>
          <span class="legal-category__item-arrow">&#x203A;</span>
        </div>
      </template>
      <div v-else class="legal-category__empty">
        抱歉，未能找到相关内容
      </div>
    </div>
    <div v-if="category.secondItems.length > defaultCount" class="legal-category__toggle">
      <span v-if="!isAllExpanded" class="legal-category__toggle-btn" @click="expandMore">
        展开更多
      </span>
      <span v-else class="legal-category__toggle-btn" @click="collapse">
        收起
      </span>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'

interface SecondItem {
  title: string
  jumpUrl: string
}

interface CategoryData {
  title: string
  secondItems: SecondItem[]
}

export default Vue.extend({
  name: 'LegalCategory',
  props: {
    category: {
      type: Object as () => CategoryData,
      required: true
    },
    isSearchMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      defaultCount: 5,
      expandStep: 10,
      displayCount: 5
    }
  },
  computed: {
    visibleItems(): SecondItem[] {
      return this.category.secondItems.slice(0, this.displayCount)
    },
    isAllExpanded(): boolean {
      return this.displayCount >= this.category.secondItems.length
    }
  },
  watch: {
    category() {
      this.displayCount = this.defaultCount
    }
  },
  methods: {
    formatTitle(title: string, index: number): string {
      const num = index + 1
      return `${num}. ${title}`
    },
    expandMore() {
      const total = this.category.secondItems.length
      this.displayCount = Math.min(this.displayCount + this.expandStep, total)
    },
    collapse() {
      this.displayCount = this.defaultCount
    },
    handleItemClick(item: SecondItem) {
      if (item.jumpUrl) {
        window.open(item.jumpUrl, '_blank')
      }
    }
  }
})
</script>

<style scoped lang="scss">
.legal-category {
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 10px;
  overflow: hidden;

  &__header {
    padding: 12px 24px;
    border-bottom: 1px solid #f0f0f0;
  }

  &__title {
    font-family: 'PingFang SC', sans-serif;
    font-size: 16px;
    font-weight: 500;
    line-height: 22px;
    color: #111;
  }

  &__list {
    width: 100%;
  }

  &__empty {
    padding: 40px 24px;
    text-align: center;
    font-family: 'PingFang SC', sans-serif;
    font-size: 14px;
    font-weight: normal;
    line-height: 22px;
    letter-spacing: normal;
    /* 中性色/一级文字 */
    color: #111111;
  }

  &__item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 24px;
    cursor: pointer;
    border-bottom: 1px solid #f5f5f5;

    &:hover {
      background: #fafafa;
    }
  }

  &__item-text {
    font-family: 'PingFang SC', sans-serif;
    font-size: 14px;
    font-weight: normal;
    line-height: 22px;
    color: #111;
    flex: 1;
  }

  &__item-arrow {
    font-size: 16px;
    color: #ccc;
    margin-left: 12px;
  }

  &__toggle {
    padding: 12px 24px;
  }

  &__toggle-btn {
    font-family: 'PingFang SC', sans-serif;
    font-size: 14px;
    font-weight: normal;
    line-height: 22px;
    color: #42A0FF;
    cursor: pointer;
  }
}
</style>
